import { ScrollArea } from '@/components/ui/scroll-area';
import { Car, AlertCircle, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const TrafficSection = ({ traffic }) => {
  const navigate = useNavigate();
  
  const getSeverityColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'high': return 'severity-high';
      case 'medium': return 'severity-medium';
      case 'low': return 'severity-low';
      default: return 'severity-none';
    }
  };

  return (
    <div className="content-card" data-testid="traffic-section">
      <div className="card-header">
        <h2>
          <Car size={20} className="inline" /> Traffic Updates
        </h2>
        <Button 
          onClick={() => navigate('/traffic')} 
          variant="outline" 
          size="sm"
          style={{ marginLeft: 'auto', fontSize: '0.85rem', padding: '0.4rem 0.8rem' }}
          data-testid="view-full-traffic-button"
        >
          View Full Map <ExternalLink size={14} style={{ marginLeft: '0.3rem' }} />
        </Button>
      </div>
      <ScrollArea className="card-content">
        {traffic.length > 0 ? (
          <div className="traffic-list">
            {traffic.slice(0, 5).map((item, index) => (
              <div key={`${item.severity}-${item.location}-${item.message}`} className={`traffic-item ${getSeverityColor(item.severity)}`} data-testid={`traffic-item-${index}`}>
                <div className="traffic-header">
                  <AlertCircle size={16} />
                  <span className="traffic-severity">{item.severity}</span>
                </div>
                <p className="traffic-message">{item.message}</p>
                {item.location && <p className="traffic-location">{item.location}</p>}
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">No traffic updates</p>
        )}
      </ScrollArea>
    </div>
  );
};

export default TrafficSection;